export default class Slider {
  init () {
    // this.initSlider('.js_slider_wrap');

    // if ($(window).width() >= 820) {
    //   $('.js_slider_sp_wrap').slick('unslick');
    //   $('.js_slider_sp_wrap_2').slick('unslick');
    //   this.initSlider('.js_slider_pc_wrap');
    // }

    if ($(window).width() < 820) {
      if (!$('.js_slider_sp_wrap .js_slider').hasClass('slick-initialized')) {
        this.initSlider('.js_slider_sp_wrap');
      }
      if (!$('.js_slider_sp_wrap_2 .js_slider').hasClass('slick-initialized')) {
        this.initSlider2('.js_slider_sp_wrap_2');
      }
    } else {
      if ($('.js_slider_sp_wrap .js_slider').hasClass('slick-initialized')) {
        $('.js_slider_sp_wrap .js_slider').slick('unslick');
      }
      if ($('.js_slider_sp_wrap_2 .js_slider').hasClass('slick-initialized')) {
        $('.js_slider_sp_wrap_2 .js_slider').slick('unslick');
      }
    }
  }

  initSlider (sliderWrapSelector) {
    $(`${sliderWrapSelector}`).each(function () {
      const $this = $(this);
      const $slider = $this.find('.js_slider');

      $this.addClass('is-initialized');

      $slider.slick({
        arrows: false,
        dots: true,
        dotsClass: 'c_slider_dots',
        appendDots: $this.find('.c_slider_dots_area'),
        customPaging: function () {
          return '<div class="c_slider_dot"></div>';
        }
      });

      $this.find('.js_slider_prev').on('click', function (e) {
        e.preventDefault();
        $slider.slick('slickPrev');
      });

      $this.find('.js_slider_next').on('click', function (e) {
        e.preventDefault();
        $slider.slick('slickNext');
      });

      const heights = [];
      $this.find('.js_match_height').each(function () {
        heights.push($(this).height());
      });
      $this.find('.js_match_height').height(Math.max(...heights));
    });
  }

  initSlider2 (sliderWrapSelector) {
    $(`${sliderWrapSelector}`).each(function () {
      const $this = $(this);
      const $slider = $this.find('.js_slider');

      $this.addClass('is-initialized');

      $slider.slick({
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: '16%'
      });

      $this.find('.js_slider_prev').on('click', function (e) {
        e.preventDefault();
        $slider.slick('slickPrev');
      });

      $this.find('.js_slider_next').on('click', function (e) {
        e.preventDefault();
        $slider.slick('slickNext');
      });

      const heights = [];
      $this.find('.js_match_height').each(function () {
        heights.push($(this).height());
      });
      $this.find('.js_match_height').height(Math.max(...heights));
    });
  }
}

/*
マークアップ例:

<div class="c_slider_wrap js_slider_wrap">
  <ul class="l_grid_column_3col c_slider js_slider">
    <li>
      <img src="https://via.placeholder.com/350x233" alt="">
      <p class="u_spacing_mt_xsmall">テキストテキストテキスト</p>
    </li>
    <li>
      <img src="https://via.placeholder.com/350x233" alt="">
      <p class="u_spacing_mt_xsmall">テキストテキストテキスト</p>
    </li>
    <li>
      <img src="https://via.placeholder.com/350x233" alt="">
      <p class="u_spacing_mt_xsmall">テキストテキストテキスト</p>
    </li>
  </ul>
  <div class="c_slider_control_area">
    <a href="" class="c_button c_button_type2 c_button_type2_l c_slider_prev js_slider_prev"></a>
    <div class="c_slider_dots_area"></div>
    <a href="" class="c_button c_button_type2 c_button_type2_r c_slider_next js_slider_next"></a>
  </div>
</div>
*/


// WEBPACK FOOTER //
// ./src/assets/js/modules/slider.js